// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3FxE2","imageUploader":"EGiftCard_imageUploader__3imYk"};